import { getService, postService } from '../api/service.js'
// 工作台订单统计
export const getDistrbutorOrderCount = params =>{ 
  return postService('api/distributor/getDistrbutorOrderCount', params)
}
// 充值
export const DistributorRechargeSelf = params =>{ 
  return postService('api/distributor/DistributorRechargeSelf', params)
}
// 站内信列表
export const getDistrbutorNewMailList = params =>{ 
  return postService('api/distributor/getDistrbutorNewMailList', params)
}
//站内信详情

export const updateDistrbutorTwoOverDraftMoney = params =>{ 
  return postService('api/distributor/updateDistrbutorTwoOverDraftMoney', params)
}
export const getDistrbutorNewMailInfo = params =>{ 
  return postService('api/distributor/getDistrbutorNewMailInfo', params)
}
// 站内信删除
export const deleteDistrbutorNewMail = params =>{ 
  return postService('api/distributor/deleteDistrbutorNewMail', params)
}
// 站内信批量阅读
export const readAllDistrbutorNewMail = params =>{ 
  return postService('api/distributor/readAllDistrbutorNewMail', params)
}

export const deleteAllDistrbutorNewMail = params =>{ 
  return postService('api/distributor/deleteAllDistrbutorNewMail', params)
}
//商品列表
export const getProductDistributorList = params =>{ 
  return postService('/api/distributor/getProductDistributorList', params)
}

// 详情
export const getProductInfo = params =>{ 
  return postService('/api/distributor/getProductDistributorInfo', params)
}


// 商品类型
export const getProductNewTypeList = params =>{ 
  return postService('/api/product/getProductNewTypeList', params)
}
// 立即下单

export const addDistributorOrder = params =>{ 
  return postService('/api/distributor/addDistributorOrder', params)
}

// 一级分销商日历票价格列表
export const getProductCld = params =>{ 
  return postService('/api/distributor/getProductCld', params)
}

// 日历票单独设置
export const aloneDistrbutorTwoCldProduct = params =>{ 
  return postService('api/distributor/aloneDistrbutorTwoCldProduct', params)
}
// 日历票日库存设置

export const saveDistrbutorTwoDayNumber = params =>{ 
  return postService('api/distributor/saveDistrbutorTwoDayNumber', params)
}
// 预订单列表
export const getResOrderList = params =>{ 
  return postService('/api/res/getResOrderList', params)
}
// 添加预订单
export const addResOrder = params =>{ 
  return postService('/api/res/addResOrder', params)
}
// 修改预订单
export const updateResOrder = params =>{ 
  return postService('/api/res/updateResOrder', params)
}
//删除预订单

export const resOrderDelete = params =>{ 
  return postService('/api/res/resOrderDelete', params)
}
// 预订单详情
export const getResOrderInfo = params =>{ 
  return postService('/api/res/getResOrderInfo', params)
}
//

// 预商品列表
export const getResDisItemAuthList = params =>{ 
  return postService('/api/res/getResDisItemAuthList', params)
}

// 景区列表
export const getDistrbutorScenicList = params =>{ 
  return postService('/api/distributor/getDistrbutorScenicList', params)
}


// 二级分销商列表
export const getImpowerDistrbutorTwoList = params =>{ 
  return postService('/api/distributor/getImpowerDistrbutorTwoList', params)
}
// 二级分销商添加修改二级业务电话
export const addDistributorTwoYeWuInfo = params =>{ 
  return postService('/api/distributor/addDistributorTwoYeWuInfo', params)
}

// 充值
export const rechargeDistrbutorTwo = params =>{ 
  return postService('/api/distributor/rechargeDistrbutorTwo', params)
}

// 充值记录
export const rechargeDistrbutorTwoRecord = params =>{ 
  return postService('/api/distributor/rechargeDistrbutorTwoRecord', params)
}


// 二级分销商详情
export const getDistributorTwoInfo = params =>{ 
  return postService('/api/distributor/getDistributorTwoInfo', params)
}
// 添加二级分销商
export const addDistributorTwo = params =>{ 
  return postService('/api/distributor/addDistributorTwo', params)
}
// 二级分销商期票授权、未授权列表
export const getProductAndDistributortwoList = params =>{ 
  return postService('/api/distributor/getProductAndDistributortwoList', params)
}
// 二级分销商日历期票授权
export const impowerDistrbutorTwoProduct = params =>{ 
  return postService('/api/distributor/impowerDistrbutorTwoProduct', params)
}

// 二级分销商日历票列表
export const getDistributortwoCldList = params =>{ 
  return postService('/api/distributor/getDistributortwoCldList', params)
}

// 批量设置

export const batchCldProduct = params =>{ 
  return postService('/api/distributor/batchCldProduct', params)
}
// 删除二级分销商

export const deleteDistributortwo = params =>{ 
  return postService('/api/distributor/deleteDistributortwo', params)
}

// 二级分销商统计

export const getDistrbutorTwoCount = params =>{ 
  return postService('/api/distributor/getDistrbutorTwoCount', params)
}

/* 系统设置 */
// 基本信息
export const getDistributorDetail = params =>{ 
  return postService('/api/distributor/getDistributorDetail', params)
}

// 余额提醒设置 保存

export const setDistributorQuotaRemind = params =>{ 
  return postService('/api/distributor/setDistributorQuotaRemind', params)
}

// 接口验证

export const setDistributorApiAccount = params =>{ 
  return postService('/api/distributor/setDistributorApiAccount', params)
}

// 管理员列表
export const getDistrbutorUserList = params =>{ 
  return postService('/api/distributor/getDistrbutorUserList', params)
}
// 管理员详情
export const getDistrbutorUserInfo = params =>{ 
  return postService('/api/distributor/getDistrbutorUserInfo', params)
}
// 管理员添加

export const addDistrbutorUser = params =>{ 
  return postService('/api/distributor/addDistrbutorUser', params)
}
// 管理员编辑

export const updateDistrbutorUser = params =>{ 
  return postService('/api/distributor/updateDistrbutorUser', params)
}
// 管理员删除
export const getDistrbutorUserDelete = params =>{ 
  return postService('/api/distributor/getDistrbutorUserDelete', params)
}

// 角色列表

export const getDistrbutorUserRoleList = params =>{ 
  return postService('/api/distributor/getDistrbutorUserRoleList', params)
}
// 角色详情
export const getDistrbutorUserRoleInfo = params =>{ 
  return postService('/api/distributor/getDistrbutorUserRoleInfo', params)
}
// 添加角色
export const addDistrbutorUserRole = params =>{ 
  return postService('/api/distributor/addDistrbutorUserRole', params)
}
// 编辑角色
export const updateDistrbutorUserRole = params =>{ 
  return postService('/api/distributor/updateDistrbutorUserRole', params)
}
// 角色删除

export const deleteDistrbutorUserRole = params =>{ 
  return postService('/api/distributor/deleteDistrbutorUserRole', params)
}
// 权限列表

export const getDistrbutorRoleNodeList = params =>{ 
  return postService('/api/distributor/getDistrbutorRoleNodeList', params)
}
// 角色授权
export const addDistrbutorRoleNode = params =>{ 
  return postService('/api/distributor/addDistrbutorRoleNode', params)
}



/* 财务模块 */

// 订单列表
export const getDistributorOrderList = params =>{ 
  return postService('/api/distributor/getDistributorOrderList', params)
}
// 退票
export const distributorRefund = params =>{ 
  return postService('/api/distributor/distributorRefund', params)
}


// 订单详情
export const getDistributorOrderInfo = params =>{ 
  return postService('/api/distributor/getDistributorOrderInfo', params)
}
// 重发短信
export const sendSms = params =>{ 
  return postService('/api/distributor/sendSms', params)
}
// 导出订单

export const distributorPostExport = params =>{ 
  return getService('/api/distributor/distributorPostExport', params)
}






// 发票配置
export const invoiceConfig = params =>{ 
  return postService('/api/close/invoiceConfig', params)
}
// 发票配置详情
export const invoiceConfigInfo = params =>{ 
  return postService('/api/close/invoiceConfigInfo', params)
}
// 发票记录 列表
export const getInfoCloseList = params =>{ 
  return postService('/api/close/getInfoCloseList', params)
}
// 发票记录详情
export const getInfoCloseInfo = params =>{ 
  return postService('/api/close/getInfoCloseInfo', params)
}
// 发票审核
export const invoiceCheck = params =>{ 
  return postService('/api/close/invoiceCheck', params)
}

// 打款
export const addInfoRemit = params =>{ 
  return postService('/api/close/addInfoRemit', params)
}

//打款列表
export const getInfoRemitList = params =>{ 
  return postService('/api/close/getInfoRemitList', params)
}



//费用详情
export const getCloseList = params =>{ 
  return postService('/api/close/getCloseList', params)
}
//费用详情列表

export const getInfoCloseDetailList = params =>{ 
  return postService('/api/close/getInfoCloseDetailList', params)
}

// 确认结算
export const affirm = params =>{ 
  return postService('/api/close/affirm', params)
}


//消费统计

export const getDistributorXFTJ = params =>{ 
  return postService('/api/distributor/getDistributorXFTJ', params)
}
//销售统计

export const getDistributorXSTJ = params =>{ 
  return postService('/api/distributor/getDistributorXSTJ', params)
}
//退票统计
export const getDistributorTPTJ = params =>{ 
  return postService('/api/distributor/getDistributorTPTJ', params)
}
//消费统计明细

export const getDistributorXFRecord = params =>{ 
  return postService('/api/distributor/getDistributorXFRecord', params)
}
//退票统计明细

export const getDistributorTPRecord = params =>{ 
  return postService('/api/distributor/getDistributorTPRecord', params)
}
// 退票导出
export const getDistributorTPRecordExport = params =>{ 
  return getService('/api/distributor/getDistributorTPRecordExport', params)
}
// 消费导出
export const getDistributorXFRecordExport = params =>{ 
  return getService('/api/distributor/getDistributorXFRecordExport', params)
}
export const impowerDistrbutorTwoProductCld = params =>{ 
  return postService('api/distributor/impowerDistrbutorTwoProductCld', params)
}
export const cancelImpowerDistrbutorTwoProduct = params =>{ 
  return postService('api/distributor/cancelImpowerDistrbutorTwoProduct', params)
}
// 批量下单

export const addDistributorBatchOrder = params =>{ 
  return postService('api/distributor/addDistributorBatchOrder', params)
}

// 批量下单列表

export const getDistributorBatchOrderList = params =>{ 
  return postService('api/distributor/getDistributorBatchOrderList', params)
}

// 批量订单结果数据
export const getBatchResultData = params =>{ 
  return postService('api/scenicorder/getBatchResultData', params)
}
export const rechargeDistributorRecord = params =>{ 
  return postService('api/distributor/rechargeDistributorRecord', params)
}